import PaymentMethods from './PaymenMethods'
export default PaymentMethods
